import { render } from "./LegalLinks.vue?vue&type=template&id=2465beca&scoped=true"
import script from "./LegalLinks.vue?vue&type=script&lang=js"
export * from "./LegalLinks.vue?vue&type=script&lang=js"

import "./LegalLinks.vue?vue&type=style&index=0&id=2465beca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2465beca"]])

export default __exports__